<div class="content">
  <div class="columns">
    <div class="column is-6">
      <ng-select [items]="categories" bindLabel="name" [virtualScroll]="true" class="custom has-tooltip-top"
                 placeholder="None" [ngModel]="selectedCategory" (ngModelChange)="select($event)"
                 data-tooltip="Mutation type to be considered for edge weights." [clearable]="true">
        <ng-template ng-option-tmp let-item="item">
          {{item.name}}
        </ng-template>
      </ng-select>
    </div>

  </div>
</div>
